module.exports = __webpack_public_path__ + "static/media/vip-store.3072b5a6.svg";